import React from 'react';
import { formatCurrency } from '@/utils/money';
import { PricingRecommendationRow } from '@/experiences/sales-portal/domain/pricing-agent/screens/types';
import { Typography } from '@usepepper/ui/atoms/typography';
import { useRecommendationActionsStore } from '@/experiences/sales-portal/domain/pricing-agent/blocs/stores/recommendation-actions-store';

interface Props {
  currencyCode: string;
  row: PricingRecommendationRow;
}

export const AgentGrossProfitCell = React.memo<Props>(
  ({ currencyCode, row }) => {
    const overridePriceInMicros = useRecommendationActionsStore(
      (state) => state.actions[row.uuid]?.overridePriceInMicros,
    );

    const effectivePriceInMicros =
      overridePriceInMicros ?? row.newPriceInMicros;
    const grossProfit = effectivePriceInMicros - row.snapshotCostInMicros;

    return (
      <Typography variant="paragraph-md">
        {formatCurrency(grossProfit, currencyCode)}
      </Typography>
    );
  },
);
